declare global {
  interface Window {
    ym?: (
      counterId: number,
      action: string,
      goalId: string,
      params?: Record<string, any>
    ) => void;
  }
}

const COUNTER_ID = 104616172;

export const YandexMetrika = {
  reachGoal: (goalId: string, params?: Record<string, any>) => {
    try {
      if (typeof window !== "undefined" && window.ym) {
        window.ym(COUNTER_ID, "reachGoal", goalId, params);
        console.log(`📊 [YM] Цель достигнута: ${goalId}`, params || "");
      } else {
        console.warn("⚠️ [YM] Яндекс.Метрика не инициализирована");
      }
    } catch (error) {
      console.error("❌ [YM] Ошибка отправки цели:", error);
    }
  },

  // Локации и геолокация
  setDpsLocation: () => {
    YandexMetrika.reachGoal("set_dps_location");
  },

  setMyLocationOn: () => {
    YandexMetrika.reachGoal("set_my_location_on");
  },

  // Навигация по разделам
  goToProfile: () => {
    YandexMetrika.reachGoal("go_to_profile");
  },

  goToSettings: () => {
    YandexMetrika.reachGoal("go_to_settings");
  },

  goToFlowers: () => {
    YandexMetrika.reachGoal("go_to_flowers");
  },

  goToNetworking: () => {
    YandexMetrika.reachGoal("go_to_networking");
  },

  goToContest: () => {
    YandexMetrika.reachGoal("go_to_contest");
  },

  goToSvodka: () => {
    YandexMetrika.reachGoal("go_to_svodka");
  },

  goToGift: () => {
    YandexMetrika.reachGoal("go_to_gift");
  },

  // Нетворкинг - открытие профиля пользователя в ленте
  openUserProfile: () => {
    YandexMetrika.reachGoal("open_user_profile");
  },

  // Нетворкинг - открытие вкладки контакты
  openContacts: () => {
    YandexMetrika.reachGoal("open_contacts");
  },

  // Нетворкинг - открытие вкладки запросы
  openRequests: () => {
    YandexMetrika.reachGoal("open_requests");
  },

  // Нетворкинг - добавление в друзья
  addFriend: () => {
    YandexMetrika.reachGoal("add_friend");
  },

  // Нетворкинг - удаление из друзей
  removeFriend: () => {
    YandexMetrika.reachGoal("remove_friend");
  },

  // Нетворкинг - удаление профиля
  deleteProfile: () => {
    YandexMetrika.reachGoal("delete_profile");
  },

  // Нетворкинг - редактирование профиля
  editProfile: () => {
    YandexMetrika.reachGoal("edit_profile");
  },

  // Нетворкинг - открытие чата с пользователем
  openChat: () => {
    YandexMetrika.reachGoal("open_chat");
  },

  // Фильтры карты
  toggleTrafficFilter: (isEnabled: boolean) => {
    const goalName = isEnabled ? "traffic_filter_on" : "traffic_filter_off";
    YandexMetrika.reachGoal(goalName);
  },

  toggleDpsFilter: (isEnabled: boolean) => {
    const goalName = isEnabled ? "dps_filter_on" : "dps_filter_off";
    YandexMetrika.reachGoal(goalName);
  },

  toggleWebcamsFilter: (isEnabled: boolean) => {
    const goalName = isEnabled ? "webcams_filter_on" : "webcams_filter_off";
    YandexMetrika.reachGoal(goalName);
  },

  toggleCleanFilter: (isEnabled: boolean) => {
    const goalName = isEnabled ? "clean_filter_on" : "clean_filter_off";
    YandexMetrika.reachGoal(goalName);
  },

  toggleDtpFilter: (isEnabled: boolean) => {
    const goalName = isEnabled ? "dtp_filter_on" : "dtp_filter_off";
    YandexMetrika.reachGoal(goalName);
  },

  // Клик по маркеру на карте
  mapEventIconClick: (type: "dps" | "clean" | "dtp" | "camera") => {
    const goalName = `map_event_icon_click_${type}`;
    YandexMetrika.reachGoal(goalName);
  },
};
